(function() {
  // --- Keep the sticky cart's Loox rating scoped to the current product ---
  function formatStickyCartReviews() {
    const reviewContainer = document.querySelector('.satcb_reviews_stars');
    if (!reviewContainer) return;

    // The sticky-cart app sometimes leaves its rating container empty even after
    // Loox has rendered a valid rating beside the current product. Mirror that
    // current-product rating into the bar; never source it from recommendation cards.
    let hasRatingContent = Boolean(reviewContainer.querySelector('.loox-rating-content'));
    const productRatingContent = document.querySelector('.product--outer .loox-rating-content');

    if (!hasRatingContent && productRatingContent) {
      const stickyRating = document.createElement('div');
      stickyRating.className = 'loox-rating satcb-loox-rating';
      stickyRating.appendChild(productRatingContent.cloneNode(true));
      reviewContainer.replaceChildren(stickyRating);
      hasRatingContent = true;
    }

    // When the current product has no reviews, the sticky-cart app can fall back to
    // every Loox star SVG on the page (including related-product cards). Those
    // incorrect stars are direct children; a real product rating is wrapped in
    // .loox-rating-content.
    const hasDirectStars = Array.from(reviewContainer.children)
      .some((child) => child.matches('svg.loox-icon'));

    if (hasDirectStars && !hasRatingContent) {
      reviewContainer.replaceChildren();
      reviewContainer.style.setProperty('display', 'none', 'important');
      reviewContainer.dataset.looxInvalidFallback = 'true';
      return;
    }

    if (!hasRatingContent) return;

    // Restore the container now that a genuine current-product rating is present,
    // then wrap just the count so CSS can hide it on mobile.
    reviewContainer.style.removeProperty('display');
    delete reviewContainer.dataset.looxInvalidFallback;

    const ratingLabel = reviewContainer.querySelector('.loox-rating-label');
    if (!ratingLabel || ratingLabel.querySelector('.satcb-review-count')) return;

    const labelText = ratingLabel.textContent.replace(/\u00a0/g, ' ').trim();
    const labelParts = labelText.match(/^(.+?)\s*(\([^)]*\))$/);
    if (labelParts) {
      const count = document.createElement('span');
      count.className = 'satcb-review-count';
      count.textContent = ` ${labelParts[2]}`;
      ratingLabel.replaceChildren(
        document.createTextNode(`\u00a0${labelParts[1].trim()}`),
        count
      );
    }
  }

  // --- Currency setup (covers every market the EU storefront sells to) ---
  // ISO codes Shopify may suffix on raw money output (e.g. "199,95 SEK").
  const removableSuffixes = [
    'AUD','CAD','NZD','EUR','GBP','USD',
    'SEK','NOK','DKK','CZK','PLN','HUF','RON','BGN','CHF'
  ];
  // ISO -> visible symbol. `kr` is shared across SEK/NOK/DKK; we resolve which one
  // to display from whichever ISO suffix Shopify emits — the customer always sees
  // their own market's currency anyway, so showing just `kr` is unambiguous in context.
  const isoToSymbol = {
    AUD:'A$', CAD:'CA$', NZD:'NZ$', USD:'$', EUR:'€', GBP:'£',
    SEK:'kr', NOK:'kr', DKK:'kr', CZK:'Kč', PLN:'zł',
    HUF:'Ft', RON:'lei', BGN:'лв.', CHF:'CHF'
  };
  // Default symbol position when no leading/trailing symbol appears in the raw text.
  // Most EU non-Eurozone currencies place the symbol after the number per native typography.
  const trailingByDefault = ['SEK','NOK','DKK','CZK','PLN','HUF','RON','BGN'];

  // Symbols ordered longest-first for greedy regex match.
  // `kr.` (with dot, sometimes used for DKK) is matched before `kr`; `лв.` before `лв`.
  const symbolAlternation = ['CA\\$','NZ\\$','A\\$','CHF','kr\\.','Kč','zł','Ft','lei','лв\\.','лв','kr','€','£','\\$'].join('|');
  const leadingSymbolRe  = new RegExp('^(' + symbolAlternation + ')\\s*');
  const trailingSymbolRe = new RegExp('\\s*(' + symbolAlternation + ')$');

  const krCurrencies = new Set(['SEK', 'NOK', 'DKK']);
  const symbolToISO = {
    '€':'EUR', '£':'GBP', 'CHF':'CHF', 'Kč':'CZK', 'zł':'PLN', 'Ft':'HUF',
    'lei':'RON', 'лв.':'BGN', 'лв':'BGN', 'A$':'AUD', 'CA$':'CAD', 'NZ$':'NZD'
  };
  function krGroupSeparator(iso) {
    if (iso === 'DKK') return '.';
    if (iso === 'SEK' || iso === 'NOK') return ' ';
    return '';
  }
  function getActiveCurrency() {
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return 'EUR';
  }
  function eurStyle() {
    const country = (typeof Shopify !== 'undefined' && Shopify.country) ? String(Shopify.country).toUpperCase() : '';
    const seg = (window.location.pathname.split('/')[1] || '').toLowerCase().split('-')[0];
    if (country === 'IE') return { after: false, dot: true };
    if (country === 'NL' || (seg === 'nl' && country !== 'BE')) return { after: false, dot: false };
    return { after: true, dot: false };
  }
  function parseKrAmount(str) {
    const tokens = str.match(/(?:\d{1,3}(?:[\s.,]\d{3})+|\d+)(?:[.,]\d{1,2})?/g);
    if (!tokens || !tokens.length) return null;
    const last = tokens[tokens.length - 1];
    const decPos = Math.max(last.lastIndexOf('.'), last.lastIndexOf(','));
    let whole, frac = null;
    if (decPos !== -1) {
      const after = last.slice(decPos + 1);
      if (after.length <= 2 && /^\d+$/.test(after)) {
        frac = after.length === 1 ? after + '0' : after;
        whole = last.slice(0, decPos).replace(/\D/g, '');
      } else {
        whole = last.replace(/\D/g, '');
      }
    } else {
      whole = last.replace(/\D/g, '');
    }
    return whole ? { whole, frac } : null;
  }
  function groupThousands(digits, sep) {
    return sep ? digits.replace(/\B(?=(\d{3})+(?!\d))/g, sep) : digits;
  }

  const containersSelector = [
    '.price__current', '.satcb_price', '.satcb_was_price', '.cart-item--sale-price',
    '.atc-subtotal--price', '.atc--product-details--price-value',
    '.cart-item--content-price', '.cart-item__total',
    '.cart-subtotal', '.atc-banner--cart-subtotal',
    '.cart-title-total--small',
    '.cart-complementary__price-row',
    '.options-selection__swatch-card-price',
    '.savings',
    '.voucher-amount',
    '.complementary-product__price'
  ].join(',');

  function getFormattedPriceHTML(rawText) {
    let cleaned = rawText.trim().replace(/^C\$/, 'CA$');
    let symbol = null;
    let symbolAtEnd = false;
    let isoSuffix = null;

    // 1) Strip ISO suffix (e.g. "199,95 SEK") — authoritative for kr disambiguation.
    const sufMatch = cleaned.match(/([\d.,]+)\s*([A-Z]{3})$/);
    if (sufMatch && removableSuffixes.includes(sufMatch[2])) {
      isoSuffix = sufMatch[2];
      cleaned = cleaned.replace(/\s*[A-Z]{3}$/, '').trim();
      symbol = isoToSymbol[isoSuffix];
      symbolAtEnd = trailingByDefault.includes(isoSuffix);
    }

    // 2) Leading symbol overrides the ISO inference.
    const leadMatch = cleaned.match(leadingSymbolRe);
    if (leadMatch) {
      symbol = leadMatch[1];
      cleaned = cleaned.replace(leadingSymbolRe, '').trim();
      symbolAtEnd = false;
    } else {
      // 3) Trailing symbol — strip it whether or not we already inferred from ISO,
      //    so the number portion is clean.
      const tailMatch = cleaned.match(trailingSymbolRe);
      if (tailMatch) {
        if (!symbol) symbol = tailMatch[1];
        cleaned = cleaned.replace(trailingSymbolRe, '').trim();
        symbolAtEnd = true;
      }
    }

    if (!symbol) return null;

    const iso = isoSuffix || symbolToISO[symbol] || getActiveCurrency();
    const isKr = krCurrencies.has(iso);
    if (isKr) { symbol = iso === 'DKK' ? 'kr.' : 'kr'; symbolAtEnd = true; }

    // 4) Parse number into whole + fraction.
    let whole, frac;
    if (isKr) {
      const parts = parseKrAmount(cleaned);
      if (!parts) return null;
      whole = groupThousands(parts.whole, krGroupSeparator(iso));
      frac = parts.frac === '00' ? null : parts.frac;
    } else {
      const gtokens = cleaned.match(/(?:\d{1,3}(?:[., ]\d{3})+|\d+)(?:[.,]\d{1,2})?/g);
      let numPart = (gtokens && gtokens.length ? gtokens[gtokens.length - 1] : cleaned).replace(/\s/g, '');
      const commaAsDec = numPart.lastIndexOf(',') === numPart.length - 3;
      if (commaAsDec) {
        numPart = numPart.replace(/\./g, '').replace(',', '.');
      } else {
        numPart = numPart.replace(/,/g, '');
      }
      const m = numPart.match(/^(\d+)\.(\d{2})$/) || numPart.match(/^(\d+)$/);
      if (!m) return null;
      whole = m[1];
      frac = m[2] || null;
    }

    if (iso === 'EUR') {
      const st = eurStyle();
      const amount = groupThousands(whole, st.dot ? ',' : '.') + (frac ? (st.dot ? '.' : ',') + frac : '');
      const amtSpan = `<span class="price-whole">${amount}</span>`;
      const eurSpan = st.after
        ? `<span class="price-whole price-symbol-eur-after">€</span>`
        : `<span class="price-whole">€</span>`;
      const inner = st.after ? `${amtSpan}<span class="shopsta-price-decimal"> </span>${eurSpan}` : `${eurSpan}${amtSpan}`;
      return `<span class="satcb_price_inner" data-shopsta-price>${inner}</span>`;
    }

    const wholeSpan  = `<span class="price-whole">${whole}</span>`;
    const decimal = /,\d{2}(?:\D*)$/.test(rawText.trim()) ? ',' : '.';
    const fracSpan   = frac ? `<span class="shopsta-price-decimal">${decimal}</span><span class="price-fraction">${frac}</span>` : '';
    const symbolSpan = isKr
      ? `<span class="price-whole price-symbol-kr">${symbol}</span>`
      : symbolAtEnd
        ? `<span class="price-symbol price-symbol-trailing">${symbol}</span>`
        : `<span class="price-symbol">${symbol}</span>`;
    const inner = symbolAtEnd
      ? `${wholeSpan}${fracSpan}<span class="shopsta-price-decimal"> </span>${symbolSpan}`
      : `${symbolSpan}${wholeSpan}${fracSpan}`;
    return `<span class="satcb_price_inner" data-shopsta-price>${inner}</span>`;
  }

  // Build the final price before a variant update touches the live DOM.
  window.ShopstaPrices = {
    html(raw) {
      const source = document.createElement('span');
      source.innerHTML = raw;
      return getFormattedPriceHTML(source.textContent) || raw;
    }
  };

  function formatPrices() {
    document.querySelectorAll(containersSelector).forEach(container => {
      let els = container.querySelectorAll('.money');
      if (!els.length && (container.classList.contains('money') || container.classList.contains('savings') || container.classList.contains('voucher-amount'))) els = [container];

      els.forEach(el => {
        // Self-healing — trust the DOM, not a dataset flag. If another script clobbers
        // .money innerHTML back to plain text, the .satcb_price_inner wrapper disappears
        // and we re-format on the next observer tick. (kr prices carry no .price-symbol,
        // so we key off the wrapper, not the symbol.) See UK/.com siblings for rationale.
        if (el.querySelector('.satcb_price_inner')) return;

        // Merge any standalone "CA"/"NZ"/"A" .money sibling immediately before us.
        // Some Shopify money_format strings emit the prefix as a separate span.
        const prev = el.previousElementSibling;
        if (
          prev &&
          prev.classList.contains('money') &&
          !prev.querySelector('.price-symbol')
        ) {
          const t = prev.textContent.trim();
          if (['CA','NZ','A'].includes(t)) {
            el.textContent = t + el.textContent.trim();
            prev.remove();
          }
        }

        const formattedHTML = getFormattedPriceHTML(el.textContent.trim());
        if (formattedHTML) {
          el.innerHTML = formattedHTML;
          if (el.closest('.satcb_price, .satcb_was_price')) {
            el.style.visibility = 'visible';
          }
        }
      });
    });
  }

  function handleDOMChanges() {
    formatStickyCartReviews();
    formatPrices();
  }

  function initialize() {
  handleDOMChanges();
  const relevantSelector = `${containersSelector}, .money, .satcb_reviews_stars, .loox-rating-content`;
  new MutationObserver(mutations => {
    const relevant = mutations.some(mutation => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target.parentElement;
      if (target && target.closest(relevantSelector)) return true;
      return Array.from(mutation.addedNodes).some(node =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches(relevantSelector) || node.querySelector(relevantSelector))
      );
    });
    // Delivered mutation batches run before paint, including app price rewrites.
    if (relevant) handleDOMChanges();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
